var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { cache } from "@ane/core/lib/services/PromiseCache";
import MasterDataConstants from "@ane/exp-data/lib/constants/FeatureDataConstants";
import analysisResource from "@ane/exp-data/lib/resources/AnalysisResource";
import MdsDataplaneResources from "@ane/exp-data/lib/resources/MdsDataplaneResource";
import { getExperimentationGroupIdFromPath } from "@ane/exp-data/lib/utils/ManagementGroup/ManagementGroup.utils";
import { actionClass } from "@ane/legacy/lib/decorators/ReduxDecorators";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let AnalysisPlanActions = class {
  updateAnalysisGroupEditorVisibility(isVisible) {
    return isVisible;
  }
  setAnalysisGroupInEditor(analysisGroupInEditor) {
    return analysisGroupInEditor;
  }
  getAnalysisPlan(rolloutId) {
    return __async(this, null, function* () {
      return yield analysisResource.getAnalysisPlan(rolloutId);
    });
  }
  getAvailableTemplates(workspaceId, managementGroup) {
    return __async(this, null, function* () {
      return yield analysisResource.getAvailableTemplates(workspaceId, managementGroup);
    });
  }
  removeAnalysisGroup(analysisGroupIndex) {
    return analysisGroupIndex;
  }
  undoRemoveAnalysisGroup(analysisGroupIndex) {
    return analysisGroupIndex;
  }
  saveAnalysisPlan(payload) {
    return __async(this, null, function* () {
      return payload;
    });
  }
  validateAndSaveAnalysisGroup(analysisGroupInEditor) {
    return __async(this, null, function* () {
      return analysisGroupInEditor;
    });
  }
  getShowAnalysisPlanComponent(workspaceId, managementGroup) {
    return __async(this, null, function* () {
      return yield analysisResource.getEnableCustomScorecardCreationInRollouts(workspaceId, managementGroup);
    });
  }
  getEnableCustomSideStreamTriggerBuilder(workspaceId, managementGroup) {
    return __async(this, null, function* () {
      const experimentationGroup = getExperimentationGroupIdFromPath(workspaceId, managementGroup);
      const analysisConfig = yield MdsDataplaneResources.getConfigWithType({
        workspaceId,
        experimentationGroup,
        section: MasterDataConstants.analysisConfigSection
      });
      return {
        enableCustomSideStreamTriggerBuilder: !!analysisConfig.EnableCustomSideStreamTriggerBuilder,
        withNoTrigger: !!analysisConfig.WithNoTrigger
      };
    });
  }
  setEditMode(editMode) {
    return editMode;
  }
  setVisible(isVisible) {
    return isVisible;
  }
  clearValidationErrors() {
    return {
      validationError: null
    };
  }
};
__decorateClass([
  cache()
], AnalysisPlanActions.prototype, "getShowAnalysisPlanComponent", 1);
__decorateClass([
  cache()
], AnalysisPlanActions.prototype, "getEnableCustomSideStreamTriggerBuilder", 1);
AnalysisPlanActions = __decorateClass([
  actionClass()
], AnalysisPlanActions);
const analysisPlanActions = new AnalysisPlanActions();
export {
  AnalysisPlanActions,
  analysisPlanActions as default
};
//# sourceMappingURL=AnalysisPlanActions.js.map
